import * as React from 'react';
import * as styles from './styles.css';
import { IconChevronRight } from '../icons';
export function Valuation(_ref) {
  var title = _ref.title,
      url = _ref.url,
      onClick = _ref.onClick;
  return React.createElement("div", {
    className: styles['container']
  }, React.createElement("div", {
    className: styles['text']
  }, title), React.createElement("a", {
    href: url,
    onClick: onClick,
    target: "_blank",
    rel: "noopener noreferrer",
    className: styles['link']
  }, "\u0423\u0437\u043D\u0430\u0442\u044C", ' ', React.createElement("span", null, React.createElement(IconChevronRight, null))));
}